import { Trans } from '@lingui/react'
import { shape } from 'prop-types'

import { PriceInfoType } from 'views/utils/propTypes'

const PriceInfo = props => {
  const {
    info: { text, index },
  } = props

  return text ? (
    <span className="u-color--greyLight-dark u-font-weight--normal u-no-margin o-ProductPrice__PriceInfo">
      <Trans id={text} />
      {Boolean(index) && <sup>{index}</sup>}:
    </span>
  ) : null
}

PriceInfo.propTypes = {
  info: shape(PriceInfoType),
}

PriceInfo.defaultProps = {
  info: {},
}

export default PriceInfo
